import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let timer;
    const poll = async () => {
      if (attempts.current >= 8) {
        setStatus("timeout");
        return;
      }
      attempts.current += 1;
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setStatus("paid");
          await checkAuth();
          return;
        }
        if (["failed", "expired"].includes(res.data.payment_status)) {
          setStatus("error");
          return;
        }
      } catch (e) {}
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg)] px-4">
      <div className="card p-8 max-w-md w-full text-center" data-testid="payment-success-page">
        {status === "checking" && (
          <>
            <Loader2 size={44} className="text-accent animate-spin mx-auto mb-4" />
            <h1 className="font-heading text-xl font-bold">Memverifikasi pembayaran...</h1>
            <p className="text-sm text-[var(--text-secondary)] mt-2">Mohon tunggu sebentar.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={52} className="text-bull mx-auto mb-4" />
            <h1 className="font-heading text-2xl font-extrabold">Pembayaran Berhasil!</h1>
            <p className="text-sm text-[var(--text-secondary)] mt-2 mb-6">Membership FAS Trading Anda telah aktif. Selamat trading!</p>
            <button onClick={() => navigate("/dashboard")} data-testid="go-dashboard-btn" className="w-full h-11 rounded-lg bg-[var(--accent)] text-[#07090E] font-semibold hover:bg-[var(--accent-hover)]">Ke Dashboard</button>
          </>
        )}
        {(status === "error" || status === "timeout") && (
          <>
            <XCircle size={52} className="text-bear mx-auto mb-4" />
            <h1 className="font-heading text-xl font-bold">{status === "timeout" ? "Pembayaran Belum Terkonfirmasi" : "Terjadi Kesalahan"}</h1>
            <p className="text-sm text-[var(--text-secondary)] mt-2 mb-6">{status === "timeout" ? "Status pembayaran belum terkonfirmasi. Jika sudah membayar, coba muat ulang beberapa saat lagi." : "Kami tidak dapat memverifikasi pembayaran Anda."}</p>
            <button onClick={() => navigate("/dashboard")} data-testid="back-home-btn" className="w-full h-11 rounded-lg bg-[var(--surface-hover)] border border-[var(--border)] font-semibold">Kembali</button>
          </>
        )}
      </div>
    </div>
  );
}
